import { createEmptySurfaceStore } from 'owa-calendar-surface-dategrid';
import { createStore } from 'satcheljs';

export const getSurfaceStore = createStore(
    'publishedCalendarSurfaceStore',
    createEmptySurfaceStore()
);
